import { useEffect } from 'react'
import { useNewCode } from '@calendly/feature-check-react'
import { Logger } from '@calendly/logging-service'
/**
 * A component that deliberately throws an error when the feature flag is enabled
 * Used for testing error handling and fallback UIs
 */
export const ErrorComponent = ({ children }) => {
  const enabled = useNewCode('growth_test_error_should_cause_error')?.enabled

  useEffect(() => {
    if (enabled) {
      const message = 'This error was intentionally thrown because the feature flag "growth_test_error_should_cause_error" is enabled'
      Logger.error(message)
      throw new Error(message)
    }
  }, [enabled])

  return children || null
}
